import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { setAuthToken, setSalesState } from "../../actions";

const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  // eslint-disable-next-line
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

const PrivateRoute = class extends React.Component {
  render() {
    const { component: Component, auth, location, ...rest } = this.props;
    if (window.location.search.indexOf("PS") !== -1) {
      this.props.setSalesState(1);
    }
    if (!auth.isAuthenticated) {
      const authtoken =
        getParameterByName("AUTH", location.search) ||
        sessionStorage.getItem("AUTH");
      if (authtoken) {
        sessionStorage.setItem("AUTH", authtoken);
        this.props.setAuthToken(authtoken);
      }
    }
    return (
      <Route
        {...rest}
        render={props =>
          auth.isAuthenticated ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location }
              }}
            />
          )
        }
      />
    );
  }
};
const mapStateToProps = state => {
  return {
    auth: state.auth
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setAuthToken: token => dispatch(setAuthToken(token)),
    setSalesState: state => dispatch(setSalesState(state))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivateRoute);
